import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricImpr extends MetricBase {
    constructor() {
        super({
            field: "metric_impr",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.kayak.impr.chartName"),
            serieLabel: i18n.t("metrics.kayak.impr.serieLabel"),
            tooltip: i18n.t("metrics.kayak.impr.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricImpr;
